<section class="wtt-section">
  <!-- Background Illustration -->
  <div class="wtt-bg-illustration">
    <img src="assets/img/company/Section.png" alt="Background Illustration" />
  </div>

  <div class="wtt-inner">
    <div class="wtt-header">
      <h2 class="wtt-title">Why Top Teams Choose UpCareer AI</h2>
      <p class="wtt-subtitle">
        Elevate your hiring process with tools designed for precision, speed, and fairness.
      </p>
    </div>
    
    <div class="wtt-grid">
      <div class="wtt-card" *ngFor="let f of whyFeatures">
        <div class="wtt-icon" [ngStyle]="{ 'background-color': f.iconBg, color: f.iconColor }">
          <i class="bi {{ f.icon }}"></i>
        </div>
        <h3 class="wtt-card-title">{{ f.title }}</h3>
        <p class="wtt-card-desc">{{ f.desc }}</p>
      </div>
    </div>
  </div>
</section>

